// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OaG9q","field":"styles_field__3m9Lt","fieldCol":"styles_fieldCol__3aB2D","diffCol":"styles_diffCol__3r_rG","diff":"styles_diff__WKnEa"};